import { useEffect, useState } from "react";
import API from "../services/api";
import "./Playground.css";

export default function Playground() {
  const [creators, setCreators] = useState([]);
  const [index, setIndex] = useState(0);
  const [inputs, setInputs] = useState({});
  const [feedback, setFeedback] = useState("");

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const res = await API.get("/creators");
        setCreators(res.data || []);
        if (res.data?.length > 0) setInputs(res.data[0]);
      } catch (err) {
        console.error("Failed to load creators", err);
      }
    };
    fetchCreators();
  }, []);

  const currentCreator = creators[index];

  const handleChange = (field, value) => {
    setInputs(prev => ({ ...prev, [field]: Number(value) }));
  };

  // Formulas
  const alphaScore = Math.round(
    0.35 * ((inputs.avg_views || 0) / (inputs.followers || 1)) +
    0.25 * (inputs.engagement_rate || 0) +
    0.20 * (inputs.consistency || 0) +
    0.20 * (inputs.virality || 0)
  );

  const momentumIndex = Math.round(
    ((inputs.avg_views || 0) / (inputs.followers || 1)) * (inputs.posting_freq || 1) * 100
  );

  const viralityIndex = Math.round(
    (((inputs.likes || 0) / (inputs.avg_views || 1)) +
     ((inputs.shares || 0) / (inputs.avg_views || 1))) * 100
  );

  const discoveryScore = inputs.followers < 10000 ? "Early"
    : inputs.followers < 100000 ? "Mid"
    : "Late";

  const campaignReady = (inputs.consistency > 70 && inputs.brand_safe && inputs.audience_quality > 60)
    ? "Yes" : "Needs Review";

  return (
    <div className="playground">
      {currentCreator && (
        <>
          <h2>Creator Intelligence Playground</h2>
          <h3>{currentCreator.creator_name}</h3>

          <div className="inputs-grid">
            <label>Followers
              <input type="number" value={inputs.followers || 0}
                onChange={e => handleChange("followers", e.target.value)} />
            </label>
            <label>Avg Views
              <input type="number" value={inputs.avg_views || 0}
                onChange={e => handleChange("avg_views", e.target.value)} />
            </label>
            <label>Engagement Rate %
              <input type="number" value={inputs.engagement_rate || 0}
                onChange={e => handleChange("engagement_rate", e.target.value)} />
            </label>
            <label>Consistency %
              <input type="number" value={inputs.consistency || 0}
                onChange={e => handleChange("consistency", e.target.value)} />
            </label>
            <label>Virality %
              <input type="number" value={inputs.virality || 0}
                onChange={e => handleChange("virality", e.target.value)} />
            </label>
          </div>

          <div className="metrics-grid">
            <div className="metric"><h4>Alpha Score</h4><p>{alphaScore}</p></div>
            <div className="metric"><h4>Momentum Index</h4><p>{momentumIndex}</p></div>
            <div className="metric"><h4>Virality Index</h4><p>{viralityIndex}%</p></div>
            <div className="metric"><h4>Discovery Score</h4><p>{discoveryScore}</p></div>
            <div className="metric"><h4>Campaign Ready</h4><p>{campaignReady}</p></div>
          </div>

          <div className="nav-buttons">
            <button onClick={() => setIndex((index - 1 + creators.length) % creators.length)}>Prev</button>
            <button onClick={() => setIndex((index + 1) % creators.length)}>Next</button>
          </div>

          <div className="feedback-form">
            <h4>Feedback</h4>
            <textarea value={feedback} onChange={e => setFeedback(e.target.value)}
              placeholder="Does this resonate with how you evaluate creators?" />
            <button onClick={() => alert("Feedback submitted: " + feedback)}>Submit</button>
          </div>
        </>
      )}
    </div>
  );
}
